//=================================================
//    summary: DCP Lessons 視窗 -- Hook
//
//    remarks: 000 Tim 2021/11/08 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//             002 Tim 2022/11/02 加入 多重登入 阻擋視窗 機制
//             003 Tim 2023/09/07 開啟DCPAssessmentUrl App
//                                不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssLessons from './Lessons.module.scss'
import ToolBarTopUnit from '../Tool/ToolBarTopUnit/ToolBarTopUnit'
import ToolBarBottomUnit from '../Tool/ToolBarBottomUnit/ToolBarBottomUnit'
import OpenWebWindow from '../Tool/OpenWebWindow/OpenWebWindow'
import BCAppsWindows from '../Tool/BCAppsWindows/BCAppsWindows'
import ResourcesToolTip from '../Tool/ResourcesToolTip/ResourcesToolTip'

// import DownloadAnotherAppWindow from '../Tool/DownloadAnotherAppWindow/DownloadAnotherAppWindow'

// // 準備移除 App 取得資料 流程   Tim22.08.09
import * as WebDataAccess from '../Utils/WebDataAccess'

import {ClientGatewayInPackage, GlobalLibs, TimeZoneLibs, PackageVariablesLibs, LoadingMask, AlertWindow, CredentialMultiInWindow, RoutePathLibs} from 'bc-react-package'

// #region Member Variables
let mblnIfNeed2GoToApplicationHomePage = null

let mblnInitialized = false
let mobjShowComponentParam = null
let mintLUCatSeqNo4GoToLearningUnit = -1
let mobjAuthorizedSubscription = null

let mfuncToolBarBottomUnitOpenSettings = null
// #endregion Member Variables


const COMP_NAME = "Lessons"

function Lessons(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [bookSeqNo, setBookSeqNo] = useState(window.gSession.App.BookSeqNo)

    const [isShowOpenWebWindow, setIsShowOpenWebWindow] = useState(false)
    const [isShowBCAppsWindows, setIsShowBCAppsWindows] = useState(false)
    const [isShowResourcesToolTip, setIsShowResourcesToolTip] = useState(false)
    // const [showDownloadAnotherAppWindow, setShowDownloadAnotherAppWindow] = useState(false) // 顯示/隱藏 下載iOS App DCPAssessment

    const [showLoadingMask, setShowLoadingMask] = useState(false)
    const [loadingMaskMessage, setLoadingMaskMessage] = useState("")
    const [showAlert, setShowAlert] = useState(false)
    const [alertObject, setAlertObject] = useState(null)
    const [showCredentialMultiIn, setShowCredentialMultiIn] = useState(false)
    const [credentialMultiInArguments, setCredentialMultiInArguments] = useState(null)
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)

    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mblnIfNeed2GoToApplicationHomePage = RoutePathLibs.CheckIfNeed2GoToApplicationHomePage(props.history)

        console.log(COMP_NAME + ".Begin: mblnIfNeed2GoToApplicationHomePage: ", mblnIfNeed2GoToApplicationHomePage)
        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            let objWindowRefs = {
                OpenLoadingMask: OpenLoadingMask,
                CloseLoadingMask: CloseLoadingMask,
                ShowAlert: ShowAlert,
                ShowCredentialMultiInWindow: ShowCredentialMultiInWindow
            }
            // AAALibs.RegisterCallerWindownFuncRefs(objWindowRefs)
            GlobalLibs.RegisterCallerWindownFuncRefs(objWindowRefs)

            mrefPaintedMe.current()
        } // end of if (!mblnIfNeed2GoToApplicationHomePage)

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            if (!mblnIfNeed2GoToApplicationHomePage)
            {
                // AAALibs.UnRegisterCallerWindownFuncRefs()
                GlobalLibs.UnRegisterCallerWindownFuncRefs()

                window.ComponentFuncEntry.LessonsRef = null
            }

            mblnInitialized = false
            setUpdateDataTime(0)
        }
    }, [props.history])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 Prelude
    remarks: 000 Tim 2021/11/08 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function PreludeOnTapHandler()
    {
        console.log(COMP_NAME + ".PreludeOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // // 準備移除 App 取得資料 流程   Tim22.08.09
        // if (window.gSession.App.InApp)
        // {
        //     GetPreludeFromAppProcessBegin()
        // }
        // else
        // {
        GoToPrelude()
        // }
    } // end of PreludeOnTapHandler

    /*===========================================
    summary: 點選 Book
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function BookUnitOnTapHandler(StateBookSeqNo, BookSeqNo)
    {
        console.log(COMP_NAME + ".BookUnitOnTapHandler")

        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (StateBookSeqNo !== BookSeqNo)
        {
            setBookSeqNo(BookSeqNo)

            window.gSession.App.BookSeqNo = BookSeqNo
        }
    } // end of BookUnitOnTapHandler

    /*===========================================
    summary: 點選 Lesson
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function LessonItemOnTapHandler(LessonIndex, StateBookSeqNo)
    {
        console.log(COMP_NAME + ".LessonItemOnTapHandler: ", LessonIndex)
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strBookSeqNo = StateBookSeqNo.toString().PadLeft(2)
        let strLessonID = window.gSession.App.BookDef[strBookSeqNo].Lesson[LessonIndex].ID
        console.log("LessonItemOnTapHandler: strLessonID:", strLessonID)

        let blnExpired = true;
        // 如果他是 該本書 第一個 Lesson，有試用
        if (parseInt(window.gSession.App.BookDef[strBookSeqNo].Lesson[0].ID) === parseInt(strLessonID))
        {
            blnExpired = false;
        }
        else
        {
            blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, parseInt(strBookSeqNo));
        }

        if (!blnExpired)
        {
            // 有授權
            GetLessonDataProcessBegin(strLessonID)
            // -> GetLessonDataProcessEnd
            // -> GoToLearningUnit
        }
        else
        {
            // 沒授權
            NoAuthorizedProcess(window.gSession.App.BookCatID, StateBookSeqNo, strLessonID, window.gDCPLUEnum.LessonGoals)
        }
    } // end of LessonItemOnTapHandler
    // #endregion OnTapHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")
        setShowLoadingMask(true)
        setLoadingMaskMessage(LoadingMsg)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")
        setShowLoadingMask(false)
        setLoadingMaskMessage("")
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        setAlertObject(AlertObject)
        setShowAlert(true)
    } // end of ShowAlert

    /*===========================================
    summary: 關閉 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function HideAlert()
    {
        setAlertObject(null)
        setShowAlert(false)
    } // end of HideAlert

    /*===========================================
    summary: 開啟 多重登入 阻擋視窗
    remarks: 000 Tim 2022/11/02 Create
    ===========================================*/
    function ShowCredentialMultiInWindow(Title, Message)
    {
        let objCredentialMultiInArguments = {
            "Title": Title,
            "Message": Message
        }
        setCredentialMultiInArguments(objCredentialMultiInArguments)
        setShowCredentialMultiIn(true)
    } // end of ShowCredentialMultiInWindow
    // #endregion LoadingMask and Alert Functions

    // #region ComponentCallback

    // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function DownloadAnotherAppWindowCallback(CallbackObj)
    // {
    //     console.log(COMP_NAME + ".DownloadAnotherAppWindowCallback CallbackObj: ", CallbackObj)

    //     if (CallbackObj.Action === "CloseDownloadAnotherAppWindow")
    //     {
    //         setShowDownloadAnotherAppWindow(false)
    //     }
    // }

    /*===========================================
    summary: Component 的 Callback
    remarks: 000 Tim 2021/11/03 Create
    ===========================================*/
    function ComponentCallback(CallbackObj)
    {
        console.log(COMP_NAME + ".ComponentCallback CallbackObj: ", CallbackObj)

        if (CallbackObj.Action === "OpenLoadingMask")
        {
            OpenLoadingMask(CallbackObj.Message)
        }
        else if (CallbackObj.Action === "CloseLoadingMask")
        {
            CloseLoadingMask()
        }
        else if (CallbackObj.Action === "ShowAlertWindow")
        {
            ShowAlert(CallbackObj.AlertObject)
        }
        else if (CallbackObj.Action === "ClassManagementOnTap")
        {
            OpenClassManagement()
        }
        else if (CallbackObj.Action === "AssessmentsOnTap")
        {
            GoToAssessments()
        }
        else if (CallbackObj.Action === "BCAppsOnTap")
        {
            GoToBCApps()
        }
        else if (CallbackObj.Action === "HelpOnTap")
        {
            GoToHelp()
        }
        else if (CallbackObj.Action === "GetGlossaryFromAppProcessError")
        {
            let objAlertObject = {
                Header: "",
                Body: CallbackObj.ErrMsg,
                ShowCloseButton: false,
                CallbackRef: WebProductUnitAfterProcessAlertCallBack,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        }
        else if (CallbackObj.Action === "CloseShowOpenWebWindow")
        {
            mobjShowComponentParam = null
            setIsShowOpenWebWindow(false)
        }
        else if (CallbackObj.Action === "CloseShowBCAppsWindows")
        {
            setIsShowBCAppsWindows(false)
        }
        else if (CallbackObj.Action === "CloseShowResourcesToolTip")
        {
            setIsShowResourcesToolTip(false)
        }
        else if (CallbackObj.Action === "GoToLearningUnit")
        {
            console.log(COMP_NAME + ".ComponentCallback: GoToLearningUnit LocationState: ", CallbackObj.LocationState)

            // 支援 NoteDetail 也可以 Call 過來     Tim21.11.19
            mintLUCatSeqNo4GoToLearningUnit = parseInt(CallbackObj.LocationState.LUCatSeqNo)

            window.gSession.App.BookSeqNo = parseInt(CallbackObj.LocationState.BookSeqNo)
            console.log(COMP_NAME + ".ComponentCallback: GoToLearningUnit App.BookSeqNo: ", window.gSession.App.BookSeqNo)
            setBookSeqNo(window.gSession.App.BookSeqNo)

            // 取得 Lesson資料
            GetLessonDataProcessBegin(CallbackObj.LocationState.LessonID)
        }
        else if (CallbackObj.Action === "RegisterOpenSettings")
        {
            mfuncToolBarBottomUnitOpenSettings = CallbackObj.Function
        }
        else if (CallbackObj.Action === "SettingsDirty")
        {
            // SettingsDirty = {
            //     // "ProfileEdit": false,
            //     // "PasswordChang": false,
            //     // "SubscriptionUpdate": false,
            //     "LangChange": false
            // }
            if (CallbackObj.SettingsDirty.LangChange)
            {
                setUpdateDataTime(new Date().getTime())
            }
        }
    } // end of ComponentCallback
    // #endregion ComponentCallback

    // #region ComponentFuncEntry
    /*===========================================
    summary: 接收 AppDataAccess or WebDataAccess Callback的流程
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentFuncEntry(CallObject)
    {
        console.log(COMP_NAME + ".ComponentFuncEntry: ", CallObject)

        // if (CallObject.Func === "GetPreludeEnd")
        // {
        //     GetPreludeFromAppProcessEnd()
        // }
        if (CallObject.Func === "GetLessonDataFromWebProcessEnd")
        {
            GetLessonDataProcessEnd(CallObject.LessonID)
        }
        // else if (CallObject.Func === "GetLessonDataFromAppProcessEnd")
        // {
        //     GetLessonDataProcessEnd(CallObject.LessonID)
        // }
        // else if (CallObject.Func === "GetLessonDataFromAppProcessEnd4Error")
        // {
        //     if (CallObject.ErrMsg === window.gAppUI.ERR_NoInternetService4DownloadLessonData)
        //     {
        //         let objAlertObject = {
        //             Header: "",
        //             Body: window.gAppUI.ERR_NoInternetService4DownloadLessonData,
        //             ShowCloseButton: false,
        //             CallbackRef: null,
        //             Buttons: [
        //                 {
        //                     Text: PackageVariablesLibs.UISettings.BTN_OK,
        //                     AutoFocus: true
        //                 }
        //             ]
        //         }
        //         ShowAlert(objAlertObject)
        //     }
        // }
        else
        {
            console.log(COMP_NAME + ".ComponentFuncEntry: unspported func: ", CallObject.Func)
        }
    } // end of ComponentFuncEntry
    // #endregion ComponentFuncEntry

    // #region AlertCallBack
    /*===========================================
    summary: 點選 Lessons 沒有授權 直接開授權頁面
    remarks: 000 Tim 2021/11/29 Create
    ===========================================*/
    function NoAuthorizedGoToSubscriptionAlertCallBack(BtnObject)
    {
        console.log(COMP_NAME + ".NoAuthorizedGoToSubscriptionAlertCallBack: BtnObject: ", BtnObject);

        if (BtnObject.index === 1) // BTN_OK
        {
            mfuncToolBarBottomUnitOpenSettings(mobjAuthorizedSubscription)
        }
        else
        {
            // 取消的話，清空資料
            mobjAuthorizedSubscription = null
        }
    } // end of NoAuthorizedGoToSubscriptionAlertCallBack

    /*===========================================
    summary: Web 點選購買產品 流程 提示後 CallBack
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function WebProductUnitAfterProcessAlertCallBack(BtnObject)
    {
        console.log(COMP_NAME + ".WebProductUnitAfterProcessAlertCallBack");

        if (BtnObject.index === 1) // BTN_OK
        {
            // mobjCallParam = {
            //     "BundleID": window.gConst.BUNDLE_ID,
            //     "AppVersion": process.env.REACT_APP_LOG_VERSION,
            //     "BookCategoryID": 0                                 // 特殊處理，當 BookCategoryID = 0 是， 把 BookCategoryID 1, 3 的授權都回傳
            // }
            // GetAccountAuthorized()

            // setIsShowSubscriptionReminder(false)
        }
    } // end of WebProductUnitAfterProcessAlertCallBack
    // // #endregion AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.ComponentFuncEntry.LessonsRef = ComponentFuncEntry

        // 若無提供 this.props.location.state.LessonID 則停留在Lessons此頁 不轉到LearningUnit
        // 若只提供LessonID 且 (無提供LUCatSeqNo 或 LUCatSeqNo == null 或 LUCatSeqNo < 0) 
        //      則導到 LessonID中的SectionIndex:0, SubSectionIndex:0, SubSubSectionIndex:0位置的LU 
        //      將在 ComponentFuncEntry(CallObject) 的 CallObject.Func === "GetLessonDataFromWebProcessEnd" 處理

        // 若有提供LessonID及LUCatSeqNo 則導到 此LessonID的LUCatSeqNo 
        //      將在 ComponentFuncEntry(CallObject) 的 CallObject.Func === "GetLessonDataFromWebProcessEnd" 處理
        // e.g. 從ProgressStudentView 點擊 某一個LearningUnit 會先到Lesson 再導向指定的LU
        if (
            (typeof (props.location) !== 'undefined') &&
            (props.location !== null) &&

            (typeof (props.location.state) !== 'undefined') &&
            (props.location.state !== null) &&

            (typeof (props.location.state.LessonID) !== 'undefined') &&
            (props.location.state.LessonID !== null) &&
            (parseInt(props.location.state.LessonID) > 0)
            )
        {
            console.log(COMP_NAME + ".PaintedMe: props.location.state.LessonID: ", props.location.state.LessonID)
            console.log(COMP_NAME + ".PaintedMe: props.location.state.LUSeqNo: ", props.location.state.LUSeqNo)
            console.log(COMP_NAME + ".PaintedMe: props.location.state.LUCatSeqNo: ", props.location.state.LUCatSeqNo)
            console.log(COMP_NAME + ".PaintedMe: props.location.state.LessonIndex: ", props.location.state.LessonIndex)

            if (
                (typeof (props.location.state.BookSeqNo) !== 'undefined') &&
                (props.location.state.BookSeqNo !== null) &&
                (parseInt(props.location.state.BookSeqNo) > 0)
                )
            {
                // 若無提供 BookSeqNo 則表示 沒有切換到其他的 BookSeqNo
                window.gSession.App.BookSeqNo = parseInt(props.location.state.BookSeqNo)
                console.log(COMP_NAME + ".PaintedMe: window.gSession.App.BookSeqNo:", window.gSession.App.BookSeqNo)

                setBookSeqNo(window.gSession.App.BookSeqNo)
            }

            if (
                (typeof (props.location.state.LUCatSeqNo) !== "undefined") &&
                (props.location.state.LUCatSeqNo !== null) &&
                (parseInt(props.location.state.LUCatSeqNo) > 0)
                )
            {
                mintLUCatSeqNo4GoToLearningUnit = parseInt(props.location.state.LUCatSeqNo)
            }

            // 取得 Lesson資料
            GetLessonDataProcessBegin(props.location.state.LessonID)
        } // end of if (props.location.state.LessonID !== null)

        // console.log(this.xtype + ".LoadMe Acc.ShowResourcesTip:", window.gSession.Acc.ShowResourcesTip)
        if (!window.gSession.Acc.ShowResourcesTip)
        {
            setIsShowResourcesToolTip(true)

            window.gSession.Acc.ShowResourcesTip = true
        } // end of if (!window.gSession.Acc.ShowResourcesTip)

        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe

    /*===========================================
    summary: 前往 Prelude 頁面
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GoToPrelude()
    {
        console.log("GoToPrelude")

        RoutePathLibs.Route2Path(props.history, "/Prelude")
    } // end of GoToPrelude

    /*===========================================
    summary: 取得 Lesson 標題資料
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function GetLessonTitleData(BookSeqNo)
    {
        // console.log(COMP_NAME + ".GetLessonTitleData");

        let objLessonTitleData = null
        let arrLessonTitleData = []
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)

        let blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, BookSeqNo);
        // console.log(COMP_NAME + ".GetLessonTitleData blnExpired: ", blnExpired)
        // console.log(COMP_NAME + ".GetLessonTitleData Acc.AccountAuthorized: ", window.gSession.Acc.AccountAuthorized)

        let intIndex = 0
        let intCount = window.gSession.App.BookDef[strBookSeqNo].Lesson.length

        for (intIndex = 0; intIndex < intCount; intIndex++)
        {
            objLessonTitleData = {
                "TitleEN": window.gSession.App.BookDef[strBookSeqNo].Lesson[intIndex].PrefixName + ": " + window.gSession.App.BookDef[strBookSeqNo].Lesson[intIndex].Name,
                "TitleCN": "",
                "Expired": blnExpired
            }

            // 每一本書 第一課 都免費給他使用
            if (intIndex === 0)
            {
                objLessonTitleData.Expired = false
            }

            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
            {
                objLessonTitleData.TitleCN = window.gSession.App.BookDef[strBookSeqNo].Lesson[intIndex].MajorPrefixName + ": " + window.gSession.App.BookDef[strBookSeqNo].Lesson[intIndex].MajorName;
            }
            else
            {
                objLessonTitleData.TitleCN = window.gSession.App.BookDef[strBookSeqNo].Lesson[intIndex].MinorPrefixName + ": " + window.gSession.App.BookDef[strBookSeqNo].Lesson[intIndex].MinorName;
            }

            arrLessonTitleData.push(objLessonTitleData)
        }

        // console.log(COMP_NAME + ".GetLessonTitleData arrLessonTitleData: ", arrLessonTitleData)

        return arrLessonTitleData
    } // end of GetLessonTitleData

    /*===========================================
    summary: 前往 LearningUnit
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GoToLearningUnit(LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".GoToLearningUnit")

        let strLessonID = LessonID.PadLeft(5)   // Tim幫忙補上 轉文字的正確寫法
        console.log("GoToLearningUnit: strLessonID: ", strLessonID)
        console.log("GoToLearningUnit: LUCatSeqNo: ", LUCatSeqNo)

        let objLocationState = {
            "LessonID": strLessonID,
            "LUSeqNo": LUCatSeqNo
        }
        RoutePathLibs.Route2Path(props.history, "/LearningUnit", objLocationState)
    } // end of GoToLearningUnit

    /*===========================================
    summary: 前往 Assessments的 連結
    remarks: 000 Tim 2021/11/04 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
             003 Tim 2023/09/07 iOSNewGateway 改寫 
                                不使用 之前 會開下載視窗的流程
                                改用 開其他App的新流程
    ===========================================*/
    function GoToAssessments()
    {
        const FUNC_NAME = GoToAssessments.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", window.gSession.Acc.Preferences)

        let strTimeZoneValue = ""
        if (
            (typeof (window.gSession.Acc.Preferences) !== 'undefined') &&
            (window.gSession.Acc.Preferences !== null) &&
            (typeof (window.gSession.Acc.Preferences.TimeZone) !== 'undefined') &&
            (window.gSession.Acc.Preferences.TimeZone !== null) &&
            (window.gSession.Acc.Preferences.TimeZone !== -1)
            )
        {
            strTimeZoneValue = TimeZoneLibs.GetTimeZoneValueByID(window.gSession.Acc.Preferences.TimeZone)
        } // end of if (window.gSession.Acc.Preferences.TimeZone !== -1)
        console.log(COMP_NAME + "." + FUNC_NAME + " strTimeZoneValue: ", strTimeZoneValue)

        let intClassID = -1

        if (
            (window.gSession.Acc.CurrentClassIndex >= 0) &&
            (window.gSession.Acc.Class !== null) &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
            (typeof (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) !== 'undefined') &&
            (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)
            )
        {
            intClassID = parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID)
        } // end of if (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].ClassID) > 0)

        if (!window.gSession.App.InApp)
        {
            console.log(COMP_NAME + "." + FUNC_NAME + " not In App");

            // 暫時先用笨解法 轉換環境參數   Tim15.08.19
            let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

            console.log(COMP_NAME + "." + FUNC_NAME + " window.gSession.Acc.Class: ", window.gSession.Acc.Class)

            // 增加參數 AccountID   Tim16.05.19
            let strQueryString = "Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
            strQueryString += "&LoginName=" + window.gSession.Acc.LoginName
            strQueryString += "&AccountID=" + window.gSession.Acc.ID
            strQueryString += "&CurrentClassID=" + intClassID
            strQueryString += "&TimeZone=" + strTimeZoneValue
            strQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
            strQueryString += "&lang=" + window.gSession.Acc.Preferences.Lang
            strQueryString += "&Env=" + intEnv

            let strWebSiteUrl = window.gConfig.AssessmentUrl

            mobjShowComponentParam = {
                "WebSiteUrl": strWebSiteUrl,
                "ArgList": strQueryString,
                "IsAssessments": true
            }
            setIsShowOpenWebWindow(true)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // WebCallApp
            if (window.gSession.App.iOSNewGateway)
            {
                // 不使用 之前 會開下載視窗的流程，改用 開其他App的新流程   Tim23.09.07
                let strUrl = window.gConfig.DCPAssessmentUrl
                
                let intEnv = GlobalLibs.GetIntEnv(window.gSession.App.Env)

                let strParmsQueryString = "CurrentClassID=" + intClassID    // 可以將 CurrentClassID 傳過去，方便進入該Class
                strParmsQueryString += "&TimeZone=" + strTimeZoneValue
                strParmsQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                strParmsQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                strParmsQueryString += "&AccountID=" + window.gSession.Acc.ID
                strParmsQueryString += "&Credential=" + window.gSession.Acc.Credential
                strParmsQueryString += "&Env=" + intEnv

                // In App
                var strWebSiteUrl = strUrl + "?" + strParmsQueryString
                console.log(COMP_NAME + "." + FUNC_NAME + " CallApp strWebSiteUrl: ", strWebSiteUrl)

                let intAction = window.gConst.ACTION_OPEN_BROWSER
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl)

                console.log(COMP_NAME + "." + FUNC_NAME + " strQueryString: ", strQueryString)

                ClientGatewayInPackage.CallApp(strQueryString)

                // let intAction = window.gConst.ACTION_OPEN_ANOTHER_APP_BY_URL_SCHEMES

                // let strParmsQueryString = "CurrentClassID=" + intClassID    // 可以將 CurrentClassID 傳過去，方便進入該Class
                // strParmsQueryString += "&TimeZone=" + strTimeZoneValue
                // strParmsQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                // strParmsQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
                // strParmsQueryString += "&UserName=" + window.gSession.Acc.Profile.UserName
                // strParmsQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                // strParmsQueryString += "&AccountID=" + window.gSession.Acc.ID
                // console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway strParmsQueryString: ", strParmsQueryString)

                // let strURL = window.gAppURLSchemes.DCPAssessment + "://?" + strParmsQueryString
                // let strQueryString = "Action=" + intAction
                // strQueryString += "&Credential=" + window.gSession.Acc.Credential
                // strQueryString += "&BackRoute="
                // strQueryString += "&AppUrl4Open=" + encodeURIComponent(strURL)
                // console.log(COMP_NAME + "." + FUNC_NAME + " iOSNewGateway strQueryString: ", strQueryString)

                // // 已有安裝 DCPAssessment App 且 可成功直接開 DCPAssessment App 時 不回傳
                // // 未安裝 DCPAssessment App時 會開啟失敗才回傳
                // // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackGoToDCPAssessments)
                // ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackGoToDCPAssessments)
            } // end of if (window.gSession.App.iOSNewGateway) 
            else
            {

                // call App (DCP)
                let intAction = window.gConst.ACTION_OPEN_DCP_ASSESSMENT

                //  可以將 CurrentClassID 傳過去，方便進入該Class
                let strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&CurrentClassID=" + intClassID
                strQueryString += "&TimeZone=" + strTimeZoneValue
                strQueryString += "&DST=" + window.gSession.Acc.Preferences.DST
                strQueryString += "&ClassName=" + window.gSession.Acc.Profile.ClassName
                strQueryString += "&LoginName=" + window.gSession.Acc.LoginName
                strQueryString += "&AccountID=" + window.gSession.Acc.ID

                // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
                ClientGatewayInPackage.CallApp(strQueryString)
            } // end of else
        } // end of else
    } // end of GoToAssessments

    // // remarks: 001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    // // remarks: 002 Tim 2023/09/07 開啟DCPAssessmentUrl App
    // //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function BackFromAppCallbackGoToDCPAssessments(ReturnData)
    // {
    //     console.log(COMP_NAME + ".BackFromAppCallbackGoToDCPAssessments: ", ReturnData)

    //     if (
    //         (typeof (ReturnData) !== 'undefined') &&
    //         (ReturnData !== null) &&
    //         (typeof (ReturnData.Status) !== 'undefined') &&
    //         (ReturnData.Status !== null)
    //         )
    //     {
    //         if (parseInt(ReturnData.Status) === 2)
    //         {
    //             console.log("show download another app window")
    //             // 未安裝 DCPAssessment 打開下載畫面
    //             setShowDownloadAnotherAppWindow(true)
    //         }
    //     }
    //     // window.gSession.App.AppCallbackRef = null
    // }

    /*===========================================
    summary: 開啟 BCApps
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function GoToBCApps()
    {
        console.log(COMP_NAME + ".GoToBCApps")

        setIsShowBCAppsWindows(true)
    } // end of GoToBCApps

    /*===========================================
    summary: 前往 Help的 連結
    remarks: 000 Tim 2021/11/04 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function GoToHelp()
    {
        console.log(COMP_NAME + ".GoToHelp")

        let strWebSiteUrl = window.gConfig.HelpUrl

        if (!window.gSession.App.InApp)
        {
            // 另開始窗
            window.open(strWebSiteUrl)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // In App
            let intAction = window.gConst.ACTION_OPEN_BROWSER;
            let strQueryString = "Action=" + intAction
            strQueryString += "&Credential=" + window.gSession.Acc.Credential
            strQueryString += "&BackRoute="
            strQueryString += "&Url=" + encodeURIComponent(strWebSiteUrl)

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    } // end of GoToHelp

    /*===========================================
    summary: 取得 Lesson資料 流程 開始
    remarks: 000 Tim 2021/11/09 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
    ===========================================*/
    function GetLessonDataProcessBegin(LessonID)
    {
        console.log(COMP_NAME + ".GetLessonDataProcessBegin: ", LessonID)

        // // 準備移除 App 取得資料 流程   Tim22.08.09
        // if (window.gSession.App.InApp)
        // {
        //     AppDataAccess.GetLessonDataFromAppProcessBegin(window.gSession.App.BookCatID, LessonID)    
        // }
        // else
        // {
        OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetLessonDataProcess)
        // let LessonID = "03001"
        WebDataAccess.GetLessonDataFromWebProcessBegin(window.gSession.App.BookCatID, LessonID)
        // }
    } // end of GetLessonDataProcessBegin

    /*===========================================
    summary: 取得 Lesson資料 流程 結束
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function GetLessonDataProcessEnd(LessonID)
    {
        console.log(COMP_NAME + ".GetLessonDataProcessEnd LessonID: ", LessonID)

        CloseLoadingMask()

        let intLUCatSeqNo = window.gDCPLUEnum.LessonGoals

        // 修改 不支援 LUSeqNo 格式     Tim21.11.19
        // if (
        //     (typeof(props.location) !== 'undefined') && 
        //     (props.location !== null) &&
        //     (typeof(props.location.state) !== 'undefined') && 
        //     (props.location.state !== null)
        //     )
        // {

        //     // // 暫時先支援 兩種格式 全部統一改完後，再把 LUSeqNo 拿掉     Tim20.12.28
        //     // if (
        //     //     (typeof(props.location.state.LUSeqNo) !== "undefined") &&
        //     //     (props.location.state.LUSeqNo !== null) &&
        //     //     (parseInt(props.location.state.LUSeqNo) > 0)
        //     //     )
        //     // {
        //     //     intLUCatSeqNo = parseInt(props.location.state.LUSeqNo)
        //     // }
        //     if (
        //         (typeof(props.location.state.LUCatSeqNo) !== "undefined") &&
        //         (props.location.state.LUCatSeqNo !== null) &&
        //         (parseInt(props.location.state.LUCatSeqNo) > 0)
        //         )
        //     {
        //         intLUCatSeqNo = parseInt(props.location.state.LUCatSeqNo)
        //     }
        // }

        // 支援 NoteDetail 也可以 Call 過來     Tim21.11.19
        if (mintLUCatSeqNo4GoToLearningUnit !== -1)
        {
            intLUCatSeqNo = mintLUCatSeqNo4GoToLearningUnit
            mintLUCatSeqNo4GoToLearningUnit = -1
        }

        GoToLearningUnit(LessonID, intLUCatSeqNo)
        // GoToLearningUnit(LessonID, 4) // test for developer
    } // end of GetLessonDataProcessEnd

    // /*===========================================
    // summary: 取得 Prelude資料 流程 開始
    // remarks: 000 Tim 2021/11/09 Create
    // ===========================================*/
    // function GetPreludeFromAppProcessBegin()
    // {
    //     console.log(COMP_NAME + ".GetPreludeFromAppProcessBegin")

    //     AppDataAccess.GetPreludeFromApp()
    // } // end of GetPreludeFromAppProcessBegin

    // /*===========================================
    // summary: 取得 Prelude資料 流程 結束
    // remarks: 000 Tim 2021/11/09 Create
    // ===========================================*/
    // function GetPreludeFromAppProcessEnd()
    // {
    //     console.log(COMP_NAME + ".GetPreludeFromAppProcessEnd")

    //     GoToPrelude()
    // } // end of GetPreludeFromAppProcessEnd

    /*===========================================
    summary: 沒有授權 的 後續流程，先走購買，再回到 原本選擇的Lesson
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function NoAuthorizedProcess(BookCatID, BookSeqNo, LessonID, LUCatSeqNo)
    {
        console.log(COMP_NAME + ".NoAuthorizedProcess: Not Authorized!")

        console.log(COMP_NAME + ".NoAuthorizedProcess: BookCatID: ", BookCatID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: BookSeqNo: ", BookSeqNo)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LessonID: ", LessonID)
        console.log(COMP_NAME + ".NoAuthorizedProcess: LUCatSeqNo: ", LUCatSeqNo)

        // 先不串 GoogleClass 配對這塊     Tim20.04.17
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)
        mobjAuthorizedSubscription = {
            "BookCatID": parseInt(BookCatID),
            "BookSeqNo": strBookSeqNo,
            "LessonID": LessonID,
            "LUCatSeqNo": parseInt(LUCatSeqNo),
            "SubscriptionType": -1
        }

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.ERR_GoToLUNoAuthorizedGoToIAP,
            ShowCloseButton: false,
            CallbackRef: NoAuthorizedGoToSubscriptionAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of NoAuthorizedProcess

    /*===========================================
    summary: 開啟 ClassManagement
    remarks: 000 Tim 2021/11/03 Create
             001 Tim 2023/06/19 CallApp前 清空 AppCallbackRef
             002 Tim 2023/07/06 支援 OPEN_SAFARI_VIEW
             003 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function OpenClassManagement()
    {
        let strInApp4QueryString = window.Globals.GetInAppQueryString4BCClass()

        let strWebSiteUrl = PackageVariablesLibs.SysConfig.ClassWebSiteUrl
        let strArgList = "Credential=" + window.gSession.Acc.Credential
        strArgList += strInApp4QueryString

        let strUrl = strWebSiteUrl + "?" + strArgList

        if (!window.gSession.App.InApp)
        {
            // In Web

            // 如果包在 iFrame, 會無法 Login      Tim20.12.02
            // 所以改直接另開頁面
            window.open(strUrl)
        } // end of if (!window.gSession.App.InApp)
        else
        {
            // In App
            let intCheckResult = GlobalLibs.CheckWithCurrentVersion(window.gSession.App.AppVersion, window.gConst.OPEN_SAFARI_VIEW_APP_VER)
            let intAction = -1
            let strQueryString = ""

            if (intCheckResult === -1)
            {
                // App版號 v3.1.0 b1 以前
                intAction = window.gConst.ACTION_OPEN_BROWSER
                strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&BackRoute="
                strQueryString += "&Url=" + encodeURIComponent(strUrl)

                console.log(COMP_NAME + ".OpenClassManagement CallApp OpenBrowser strQueryString: ", strQueryString)
            } // end of if (intCheckResult === -1)
            else
            {
                // App版號 v3.1.0 b2 之後
                intAction = window.gConst.ACTION_OPEN_SAFARI_VIEW
                strQueryString = "Action=" + intAction
                strQueryString += "&Credential=" + window.gSession.Acc.Credential
                strQueryString += "&Url=" + encodeURIComponent(strUrl)

                console.log(COMP_NAME + ".OpenClassManagement CallApp OpenSafariView strQueryString: ", strQueryString)
            } // end of else

            // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
            ClientGatewayInPackage.CallApp(strQueryString)
        } // end of else
    }  // end of OpenClassManagement
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 書本 圖片 Url
    remarks: 000 Tim 2021/11/08 Create
             001 Tim 2022/08/09 註解 App 取得資料 流程
             002 Tim 2022/09/01 移除 App 取得資料 流程
    ===========================================*/
    function GetBookImageStyle(ImageFN)
    {
        let strBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        let strUrl = ""

        strUrl = PackageVariablesLibs.SysConfig.FileServerURL + "BookCategory" + strBookCatID + "/image/" + ImageFN

        let objStyle = {
            backgroundImage: 'url(' + strUrl + ')'
        }

        return objStyle
    } // end of GetBookImageStyle

    /*===========================================
    summary: 取得 書本 Cls
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function GetBookUnitCls(StateBookSeqNo, BookSeqNo)
    {
        let objCls = cssLessons.divBookUnitUnSelected

        if (StateBookSeqNo === BookSeqNo)
        {
            objCls = cssLessons.divBookUnit
        }

        return objCls
    } // end of GetBookUnitCls

    /*===========================================
    summary: 取得 Lesson 元件 Cls
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function GetLessonUnitCls(Expired)
    {
        let objCls = cssLessons.divLessonSubUnit

        // 如果 過期 就 Disable
        if (Expired)
        {
            objCls = cssLessons.divLessonSubUnitDisable
        }

        return objCls
    } // end of GetLessonUnitCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: BookUnit 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentBookUnit({ StateBookSeqNo, DisplayBookSeqNo })
    {
        let intBookIndex = parseInt(DisplayBookSeqNo) - 1
        let strImageFN = window.gSession.App.BookCategoryDef.Book[intBookIndex].MajorLandscapeImgFN
        strImageFN += window.gConst.IMG_VER_POSTFIX + process.env.REACT_APP_LOG_VERSION
        let objBookStyle = GetBookImageStyle(strImageFN)

        return (
            <div className={GetBookUnitCls(StateBookSeqNo, DisplayBookSeqNo)} style={objBookStyle} onClick={() => BookUnitOnTapHandler(StateBookSeqNo, DisplayBookSeqNo)} />
        )
    } // end of ComponentBookUnit                

    /*===========================================
    summary: BookUnit Prelude 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function ComponentBookUnitPrelude()
    {
        // Prelude
        let strImageFN = window.gSession.App.BookCategoryDef.Prelude.MajorLandscapeImgFN
        strImageFN += window.gConst.IMG_VER_POSTFIX + process.env.REACT_APP_LOG_VERSION
        let objPreludeStyle = GetBookImageStyle(strImageFN)

        return (
            <div className={cssLessons.divBookUnitPrelude} style={objPreludeStyle} onClick={() => PreludeOnTapHandler()} />
        )
    } // end of ComponentBookUnitPrelude
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render ResourcesToolTip 的顯示
    remarks: 000 Tim 2022/01/12 Create
    ===========================================*/
    function RenderResourcesToolTipWrapper(StateIsShowResourcesToolTip)
    {
        if (StateIsShowResourcesToolTip)
        {
            return (
                <ResourcesToolTip CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderResourcesToolTipWrapper

    /*===========================================
    summary: Render BCAppsWindows 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderBCAppsWindowsWrapper(StateIsShowBCAppsWindows)
    {
        if (StateIsShowBCAppsWindows)
        {
            return (
                <BCAppsWindows CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderBCAppsWindowsWrapper

    /*===========================================
    summary: Render OpenWebWindow 的顯示
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function RenderOpenWebWindowWrapper(StateIsShowOpenWebWindow)
    {
        if (StateIsShowOpenWebWindow)
        {
            return (
                <OpenWebWindow WebSiteUrl={mobjShowComponentParam.WebSiteUrl}
                    ArgList={mobjShowComponentParam.ArgList}
                    IsAssessments={mobjShowComponentParam.IsAssessments}
                    CallbackRef={ComponentCallback} />
            )
        }
        else
        {
            return ""
        }
    } // end of RenderOpenWebWindowWrapper

    /*===========================================
    summary: BookUnit 顯示Component
    remarks: 000 Tim 2021/11/09 Create
    ===========================================*/
    function RenderLessonSubUnitWrapper(LessonData, LessonIndex, StateBookSeqNo)
    {
        return (
            <div className={GetLessonUnitCls(LessonData.Expired)} onClick={() => LessonItemOnTapHandler(LessonIndex, StateBookSeqNo)}>
                <div className={cssLessons.divLessonIcon} />

                <div className={cssLessons.divLessonTitle}>
                    {LessonData.TitleEN}
                </div>

                <div className={cssLessons.divLessonLine} />

                <div className={cssLessons.divLessonTitle}>
                    {LessonData.TitleCN}
                </div>
            </div>
        )
    } // end of RenderLessonSubUnitWrapper

    /*===========================================
    summary: Render LessonList Content的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderLessonListContentWrapper(StateBookSeqNo)
    {
        let arrLessonTitleData = GetLessonTitleData(StateBookSeqNo)

        return (
            <div className={cssLessons.divLessonListContent}>
                {arrLessonTitleData.map((LessonData, LessonIndex) =>
                    <div key={LessonIndex} className={cssLessons.divLessonUnit}>
                        {RenderLessonSubUnitWrapper(LessonData, LessonIndex, StateBookSeqNo)}
                    </div>
                )}
            </div>
        )
    } // end of RenderLessonListContentWrapper

    /*===========================================
    summary: Render Book Content的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderBookContentWrapper(StateBookSeqNo)
    {
        return (
            <div className={cssLessons.divBookContent}>
                <ComponentBookUnitPrelude />

                <ComponentBookUnit StateBookSeqNo={StateBookSeqNo} DisplayBookSeqNo={1} />
                <ComponentBookUnit StateBookSeqNo={StateBookSeqNo} DisplayBookSeqNo={2} />
                <ComponentBookUnit StateBookSeqNo={StateBookSeqNo} DisplayBookSeqNo={3} />
                <ComponentBookUnit StateBookSeqNo={StateBookSeqNo} DisplayBookSeqNo={4} />
            </div>
        )
    } // end of RenderBookContentWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/01 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssLessons.divContent}>
                    {RenderBookContentWrapper(bookSeqNo)}

                    {RenderLessonListContentWrapper(bookSeqNo)}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    // remarks: 001 Tim 2023/09/07 開啟DCPAssessmentUrl App
    //                             不使用 之前 會開下載視窗的流程，改用 開其他App的新流程
    // function RenderDownloadAnotherAppWindowWrapper()
    // {
    //     let objBlock = null
    //     if (showDownloadAnotherAppWindow)
    //     {
    //         objBlock = <DownloadAnotherAppWindow CallbackRef={DownloadAnotherAppWindowCallback} />
    //     }
    //     return objBlock
    // }

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        if (!mblnIfNeed2GoToApplicationHomePage)
        {
            return (
                <>
                    <div className={cssLessons.divMain}>
                        <ToolBarTopUnit Title={window.gAppUI.LBL_Lessons}
                            ButtonType={window.gButtonTypeEnum.Lessons}
                            CallbackRef={ComponentCallback} />

                        {RenderContentWrapper(updateDataTime)}

                        <ToolBarBottomUnit ButtonType={window.gButtonTypeEnum.Lessons}
                            History={props.history}
                            CallbackRef={ComponentCallback} />
                    </div>

                    {RenderOpenWebWindowWrapper(isShowOpenWebWindow)}
                    {RenderBCAppsWindowsWrapper(isShowBCAppsWindows)}
                    {RenderResourcesToolTipWrapper(isShowResourcesToolTip)}
                    {/* {RenderDownloadAnotherAppWindowWrapper()} */}

                    <LoadingMask ShowMask={showLoadingMask} Message={loadingMaskMessage} />
                    <AlertWindow ShowAlert={showAlert} AlertObject={alertObject} HideAlertFuncRef={HideAlert} />
                    <CredentialMultiInWindow ShowCredentialMultiIn={showCredentialMultiIn} 
                        CredentialMultiInArguments={credentialMultiInArguments}/>
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default Lessons